module.exports = "/_next/static/images/game-3-fingerprint-main-red-ddc7760b2913308fb4502880b4675eff.png";